<div class="layer_details__row left">
  <div class="layer_details__label">{{ label }}</div>
  <div class="layer_details__value">{{ value | lengthUnit: unitsSystem }}</div>
</div>
